import classes from "../classes";
import React from "react";

export default function NotificationButton({ amount, children, disabled, error, onClick, naked, primary, small }) {
  small = small || false;
  return (
    <button
      className={classes({
        "btn": true,
        "btn--emphasis": true,
        "btn--has-notification": amount > 0,
        "btn--is-disabled": disabled,
        "btn--naked": naked,
        "btn--error": error,
        "btn--primary": primary,
        "btn--small": small
      })}
      data-amount={amount}
      onClick={(e) => {
        if (!disabled && typeof onClick === "function") {
          onClick(e);
        }
      }}
      type="button">
      <span>
        {children}
      </span>
    </button>
  );
}
